import { atom, getDefaultStore } from 'jotai';

export const inFlightAtom = atom(0);
const store = getDefaultStore();

export const beginLoading = () => store.set(inFlightAtom, (n) => n + 1);
export const endLoading = () => store.set(inFlightAtom, (n) => Math.max(0, n - 1));

export async function withProgress<T>(p: Promise<T>): Promise<T> {
  beginLoading();
  try { return await p; } finally { endLoading(); }
}
